import React from 'react'

import { Form, Col, Button } from '_zari/core'

import { KeyEventUtil } from 'utils'

const BuscadorFormGroup = ({ buscarPorFiltro, buscando }) => {
  const [buscadorValue, setBuscadorValue] = React.useState('')

  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.functionOnEnterOrTab(() => {
        buscarPorFiltro(buscadorValue)
      }, e)
    },
    [buscarPorFiltro, buscadorValue]
  )

  const clickBuscar = React.useCallback(() => {
    buscarPorFiltro(buscadorValue)
  }, [buscarPorFiltro, buscadorValue])

  return (
    <Form.Group>
      <Col md={12}>
        <Form.InputGroup>
          <Form.InputText
            disabled={buscando}
            id='buscador-plancontable'
            name='buscador-plancontable'
            placeholder='Ingresar cuenta de 2 dígitos.'
            tabIndex={-1}
            defaultValue={buscadorValue}
            onChange={e => setBuscadorValue(e.target.value)}
            onKeyDown={onKeyDown}
            maxLength={2}
          />
          <Form.InputGroup.Append>
            <Button onClick={clickBuscar}>Buscar</Button>
          </Form.InputGroup.Append>
        </Form.InputGroup>
      </Col>
    </Form.Group>
  )
}

export default React.memo(BuscadorFormGroup)
